module.exports = __webpack_public_path__ + "static/media/visa.0cdcb263_UI.svg";